export default {
    computed: {
        auditLookupMap() {
            const gp = this.$store.state.geschaeftspartner
            const crm = this.$store.state.crm
            const korresp = this.$store.state.korrespondenz
            const dokument = this.$store.state.dokument
            const agrivivaFirma = this.$store.state.agrivivaFirma
            const map = {}
            ;[
                gp.anreden, gp.geschlechter, gp.emailtypen, gp.bonitaten,
                gp.akademischetitel, gp.interessen, gp.zivilstaende,
                gp.nationalitaeten, gp.sprachen, gp.aufenthaltsbewilligungen,
                gp.anstellungsarten, gp.aktivitaetsstati, gp.kantone,
                gp.partnerrollen, gp.qualifikationtypen, gp.niveau,
                gp.adressverwendungstypen, gp.relationtypen, gp.relationarten,
                gp.relationsstati, gp.firma_partnerrollen, gp.branche,
                gp.kompetenzstufen, gp.unterrichtssprachen, gp.einreichungstati,
                gp.sprachkenntnisse,
                gp.konkordate, gp.institutionen, gp.funktionsbereiche,
                crm.aktivitaettypen, crm.aktivitaetstati, crm.leadquellen,
                crm.leadstages, crm.leadtypen, crm.kontaktrollen,
                crm.angebotstati, crm.einsatzbereiche, crm.belegungsstati,
                korresp.kontaktarten, korresp.kontaktkategorien,
                korresp.verarbeitungsstati, korresp.versandlisten,
                dokument.dokumentkategorie,
                agrivivaFirma.hoflage, agrivivaFirma.betriebszweige,
                agrivivaFirma.bewirtschaftungsarten, agrivivaFirma.tiere,
                agrivivaFirma.nebenbetriebe, agrivivaFirma.einsatzherkunftJugendliche,
                agrivivaFirma.auswahlEinsatzbereich, agrivivaFirma.sanitaereinrichtungen,
            ].flat().forEach(item => {
                if (item?.id && item?.bezeichnung) map[item.id] = item.bezeichnung
            })
            // Nationalitaeten: Anzeigefeld ist bezeichnungMitIso, nicht bezeichnung
            gp.nationalitaeten.forEach(item => {
                if (item?.id && item?.bezeichnungMitIso) map[item.id] = item.bezeichnungMitIso
            })
            return map
        }, 
    },
}